const defaultState = {};

export default function (state = defaultState, action) {
    const stateClone = Object.assign({}, state);

    switch (action.type) {

    }

    return stateClone;
}



// WEBPACK FOOTER //
// ./src/js/reducers/PhotographyReducer.js